import * as React from 'react';

type IconButtonProps = {
  testId?: string;
  iconClass: string;
  iconWeight?: string;
  title: string;
  disabled?: boolean;
  id?: string;
  classNames?: string;
  pulse?: boolean;
  border?: boolean;
  onClick: () => void;
};

const IconButton: React.FC<IconButtonProps> = ({
  testId,
  iconClass,
  iconWeight = 'fa-light',
  title,
  disabled,
  id,
  classNames = '',
  pulse = false,
  border = true,
  onClick
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick();
  };

  return (
    <button
      id={id}
      className={`icon-button ${classNames} ${pulse ? 'primary-pulse' : ''} ${
        border ? '' : 'no-border'
      }`}
      onClick={handleClick}
      title={title}
      disabled={disabled}
      data-testid={
        testId
          ? testId
          : `icon-button-${title.toLowerCase().replace(/\s+/g, '-')}`
      }
    >
      <i className={`${iconWeight} ${iconClass}`}></i>
    </button>
  );
};

export default IconButton;
